export const departmentSidebarData = [
    { path: 'complianceDashboard', label: 'Dashboard', icon: 'dashboard' },
    { path: 'vendorList', label: 'Registered Vendors', icon: 'storefront' },
    { path: 'openShop', label: 'Not Made Entry', icon: 'store' },
    { path: 'closeShop', label: 'Shop Closed On Time', icon: 'door_sliding' },
    { path: 'dailyClose', label: 'Shop Closed Late', icon: 'history' },
    { path: 'violations', label: 'Violations Reported', icon: 'warning' },
    { path: 'shopNotOperate', label: 'In Active Users', icon: 'store' },
    { path: 'addUser', label: 'Add User', icon: 'store' },
    { path: 'viewUser', label: 'View User', icon: 'store' },
    // { path: 'dailyClose', label: 'Late Closure', icon: 'history' },
    // { path: 'openShop', label: 'Open Shop', icon: 'store' },

    { path: 'shopOpenClose', label: 'Shop Open Close', icon: 'compare_arrows' },
    { path: 'vendorRegistration', label: 'Vendor Registration', icon: 'description', activeOn: ["vendorRegistrationForm", "registerVendorList"] },
    { path: 'vendorRegistrationForm', label: 'Vendor Registration Form', icon: 'store', hide: true },
    { path: 'registerVendorList', label: 'Register Vendor List', icon: 'store', hide: true },
]